export function formatTimeAgo(value: string, now = Date.now()): string {
  const createdAt = new Date(value).getTime();

  if (Number.isNaN(createdAt)) {
    return '';
  }

  const diffMs = Math.max(now - createdAt, 0);
  const diffMinutes = Math.floor(diffMs / 60_000);

  if (diffMinutes < 1) {
    return 'now';
  }

  if (diffMinutes < 60) {
    return `${diffMinutes} min ago`;
  }

  const diffHours = Math.floor(diffMinutes / 60);

  if (diffHours < 24) {
    return `${diffHours} h ago`;
  }

  const diffDays = Math.floor(diffHours / 24);

  if (diffDays < 30) {
    return `${diffDays} d ago`;
  }

  const diffMonths = Math.floor(diffDays / 30);

  if (diffMonths < 12) {
    return `${diffMonths} mo ago`;
  }

  return `${Math.floor(diffMonths / 12)} y ago`;
}
